import { z } from 'zod';

export const platformSettingSchema = z.object({
  key: z.string().min(1),
  value: z.union([z.string(), z.number(), z.boolean()]),
  description: z.string(),
  category: z.string(),
});
export type PlatformSettingFormData = z.infer<typeof platformSettingSchema>;

export const featureFlagSchema = z.object({
  key: z.string().min(1, 'La cle est requise'),
  isEnabled: z.boolean(),
  description: z.string().min(3, 'La description est requise'),
});
export type FeatureFlagFormData = z.infer<typeof featureFlagSchema>;

export const emailSettingsSchema = z.object({
  smtpHost: z.string().min(1, "L'hote SMTP est requis"),
  smtpPort: z.number().min(1).max(65535),
  smtpUser: z.string().min(1),
  smtpPassword: z.string().min(1),
  fromEmail: z.string().email('Email invalide'),
  fromName: z.string().min(1),
});
export type EmailSettingsFormData = z.infer<typeof emailSettingsSchema>;

export const loginSchema = z.object({
  email: z.string().email('Email invalide'),
  password: z.string().min(1, 'Le mot de passe est requis'),
});
export type LoginFormData = z.infer<typeof loginSchema>;
